import { ReactNode } from 'react';
import { MuiGrid } from '../../../../../../../../../modules/material';
import { GridProps as MuiGridProps } from '@mui/material/Grid';

export interface DiscountRowProps extends MuiGridProps {
  name: ReactNode;
  price: ReactNode;
  subName?: ReactNode;
}

export default function DiscountRow(props: DiscountRowProps) {
  const { name, price, subName, ...gridProps } = props;

  return (
    <MuiGrid
      container
      item
      justifyContent="space-between"
      wrap="nowrap"
      columnSpacing={{ xs: 1 }}
      {...gridProps}
    >
      <MuiGrid item>
        <div>{name}</div>
        {subName && <div>{subName}</div>}
      </MuiGrid>
      <MuiGrid item>{price}</MuiGrid>
    </MuiGrid>
  );
}
